export function checkedAllFunction() {
    const holderParent = $(".subscribe-form-manage");
    const selectAllButton = holderParent.find(".select-all");
    const checkboxAll = holderParent.find(":checkbox");

    selectAllButton.on("click", function (e) {
        e.preventDefault();
        checkboxAll.prop("checked", true);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/checkedAllFunction.js